import { Component, Inject, OnInit, ViewChild, AfterViewInit, ElementRef } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import { LyImageCropper, ImgCropperConfig, ImgResolution, ImgCropperErrorEvent } from "@alyle/ui/image-cropper";
import { Subscription } from "rxjs";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";

import { AlertService, MediaWatcherService } from "../../_services";
import { ProfileImageHelpDialogComponent } from "../profileImageHelp";
import { AppGlobals } from "../../app.globals";

@Component({
    selector: "profile-image-dialog",
    templateUrl: "profileImageDialog.component.html",
    styleUrls: ["profileImageDialog.component.css"],
})

export class ProfileImageDialogComponent implements OnInit, AfterViewInit {
    imageSrc: string;
    croppedImage?: string;
    croppedImageType: string;
    scale: number;
    isMobilePortrait = false;
    mediaWatcherSubscription: Subscription;
    isProfileImage = false;
    isMobile = false;
    profileImageRejectedReason = null;
    imageCropperIdDocConfig: ImgCropperConfig;
    imageCropperConfig: ImgCropperConfig;

    @ViewChild(LyImageCropper) img: LyImageCropper;
    @ViewChild("_fileInput") fileInput: ElementRef;

    constructor(private dialogRef: MatDialogRef<ProfileImageDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any, private alertService: AlertService, private appGlobals: AppGlobals,
        private mediaWatcherService: MediaWatcherService, public dialog: MatDialog) {
        this.imageSrc = data.imageSrc;
        this.profileImageRejectedReason = data.profileImageRejectedReason;
        this.isProfileImage = data.isProfileImage;
    }

    ngAfterViewInit() {
        if (this.imageSrc)
            this.img.setImageUrl(this.imageSrc);
        else {
            if (!this.isProfileImage)
                this.fileInput.nativeElement.click();
        }

        setTimeout(() => {
            this.img.center();
        }, 300);
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isMobilePortrait.subscribe(isMobilePortrait => {
            this.isMobilePortrait = isMobilePortrait;
        });

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            this.imageCropperIdDocConfig = {
                width: this.isMobile ? 350 : 800, // Default `250`
                height: this.isMobile ? 240 : 550, // Default `200`,
                resizableArea: true,
                responsiveArea: true,
                output: {
                    width: 640,
                    height: 0
                }
            };

            this.imageCropperConfig = {
                width: this.isMobilePortrait ? 290 : 340,
                height:  !this.isMobilePortrait ? 370 : 240,
                resizableArea: true,
                responsiveArea: true,
                //type: "image/jpg",
                output: {
                    width: 640,
                    height: 0
                }

                //width: this.isMobilePortrait ? 150 : 200,
                //height: this.isMobilePortrait ? 150 : 250,
                //output: ImgResolution.Default    //resizes the image
            };
        });
    }

    onImageCropped(e) {
        this.croppedImage = this.isProfileImage ? e.dataURL.indexOf("image/png") !== -1 ? e.dataURL.replace("image/png", e.type ?? e.originalDataURL.split(";")[0].split(":")[1]) : e.dataURL.replace("jpeg", "jpg") : e.dataURL;
        this.croppedImageType = e.type ?? e.originalDataURL.split(";")[0].split(":")[1];
    }

    onImageReady(e) {
        if (this.isProfileImage/* && e.name*/) {
            if (e.name)
                this.croppedImage = e.originalDataURL.replace("jpeg", "jpg");

            this.croppedImageType = e.type ?? e.originalDataURL.split(";")[0].split(":")[1];
        }

        //if (!this.isProfileImage) {
        //    setTimeout(() => {
        //        this.img.fit();
        //        this.img.center();

        //        //if (this.isMobile) {
        //        //    //this.img.config.width = this.img._imgRect.xc;
        //        //    //this.img.config.height = this.img._imgRect.yc;

        //        //    //this.img.crop();

        //        //    //this.img.fitToScreen();
        //        //} else {
        //        //    this.img.fit();
        //        //    this.img.center();
        //        //}
        //    }, 100);
        //}
    }

    onImageCropError(e: ImgCropperErrorEvent) {
        if (e.name) {
            const errorText = e.error === 0 ? "Needs to be less then or equal to 1Mb" : "";

            this.alertService.showMessage(`'${e.name}' is not a valid image. ${errorText}`, "Upload Image", this.appGlobals.alertMessageTypes.error);

            setTimeout(() => {
                this.img.setImageUrl(this.imageSrc);
            }, 0);
        }
    }

    save() {
        if (this.isProfileImage) {
            if (!this.customValidation())
                return;
        }

        this.img.crop();

        this.dialogRef.close(this.croppedImage);
    }

    close() {
        this.dialogRef.close();
    }

    customValidation() {
        if (this.croppedImageType !== "image/jpeg" && this.croppedImageType !== "image/jpg") {
            this.alertService.showMessage("Only jpg files are allowed.", "Profile Image", this.appGlobals.alertMessageTypes.error);

            return false;
        }

        return true;
    }

    viewProfileImageHelp() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.height = "auto";
        dialogConfig.width = this.isMobile ? "75%" : "50%";
        dialogConfig.panelClass = "profileDialogContainer";

        this.dialog.open(ProfileImageHelpDialogComponent, dialogConfig);
    }
}